import { getOSName } from '../../util';
const keyMap = {
  Escape: 'esc',
  ' ': 'space',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  ArrowUp: 'up',
  ArrowDown: 'down',
  '-': 'minus',
  ',': 'comma',
  '.': 'period',
  '+': 'plus'
};
const numpadMap = {
  NumpadAdd: 'numpadplus',
  NumpadSubtract: 'numpadminus',
  NumpadMultiply: 'numpad*',
  NumpadDivide: 'numpad/',
  NumpadDecimal: 'numpadpoint',
  NumpadEnter: 'enter'
};
const modifierKeys = ['Control', 'Meta', 'Alt', 'Shift'];
export const getKey = (e, platform) => {
  if (!platform) platform = getOSName().toLowerCase();
  const isApple = platform === 'mac' || platform === 'ios';
  const keys = [];
  if (e.ctrlKey) {
    keys.push('ctrl');
  }
  if (e.metaKey && isApple) {
    keys.push('command');
  }
  if (e.altKey) {
    keys.push(isApple ? 'option' : 'alt');
  }

  // NOVACOMMONS-12600
  // Option key produces special characters that are not viewable on physical keyboard.
  // So instead of the produced key, we have to display the keyboard key so that user can know what to press
  const fromKeyCode = isApple && e.altKey && (e.keyCode >= 'A'.charCodeAt(0) && e.keyCode <= 'Z'.charCodeAt(0) || e.keyCode >= '0'.charCodeAt(0) && e.keyCode <= '9'.charCodeAt(0));

  // For character that requires use of Shift key, do NOT add "Shift" to the shortcut label
  // Directly use the label of the shifted key
  // refer to https://sww.sas.com/saspedia/UI_text_guidelines#Keyboard
  if (e.shiftKey && !(e.key.length === 1 && e.key !== ' ' &&
  // eslint-disable-next-line @sas/i18n/jsx-to-localize
  !e.code.startsWith('Numpad') && !fromKeyCode && !(
  // Mac doesn't produce uppercase key with command+shift

  isApple && e.key.charCodeAt(0) >= 'a'.charCodeAt(0) && e.key.charCodeAt(0) <= 'z'.charCodeAt(0)) && e.key.toLowerCase() === e.key)) {
    keys.push('shift');
  }
  let key = e.key;
  // eslint-disable-next-line @sas/i18n/jsx-to-localize
  if (e.code?.startsWith('Numpad')) {
    if (numpadMap.hasOwnProperty(e.code)) {
      key = numpadMap[e.code];
    } else {
      key = e.code;
    }
  } else if (keyMap.hasOwnProperty(e.key)) {
    key = keyMap[e.key];
  }
  if (fromKeyCode) {
    key = String.fromCharCode(e.keyCode);
  }
  if (modifierKeys.indexOf(key) === -1) keys.push(key);
  return keys.join('+').toLowerCase();
};
export const getKeyLabel = (sKey, localize, platform) => {
  function _getKeyBundle(key, param) {
    const bundleKey = `keyLabel.${key}.label`;
    const result = localize(bundleKey, param ? {
      '0': param
    } : undefined);
    if (result.endsWith(bundleKey)) {
      // no translation
      return key.toUpperCase();
    }
    return result;
  }
  if (!sKey) return '';
  if (!platform) platform = getOSName().toLowerCase();
  return sKey.split('+').map(function (key) {
    if (/^numpad.+/.test(key)) {
      return _getKeyBundle('numpad', _getKeyBundle(key.slice(6)));
    }
    if (/^f\d+$/.test(key)) {
      return _getKeyBundle('f0', key.slice(1));
    }
    if (platform === 'mac' || platform === 'ios') {
      // HTMLCOMMONS-9342
      if (key === 'backspace') {
        key = 'delete';
      } else if (key === 'delete') {
        key = 'forwardDelete';
      }
    }
    return _getKeyBundle(key);
  }).join('+');
};
//# sourceMappingURL=KeyHelper.js.map